const columnsAllDocumentAgencyIssued = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    scopedSlots: { customRender: "stt" },
    align: "center",
  },
  {
    title: "Cơ quan ban hành",
    key: "title",
    dataIndex: "title",
    scopedSlots: { customRender: "titleAgency" },
    sorter: (a, b) => a.title.localeCompare(b.title),
    width: 250,
  },
  {
    title: "Địa chỉ",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Trạng thái",
    key: "status",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
    align: "center",
  },
  // {
  //   title: "Tạo bởi",
  //   key: "author",
  //   scopedSlots: { customRender: "author" },
  // },
  {
    title: "Ngày tạo",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
  },
  {
    title: "Cập nhật lần cuối",
    key: "updatedAt",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

export { columnsAllDocumentAgencyIssued };
